<template>
  <div class="bmi-container">
    <div class="bmi-flex">
      <div class="flag" :style="{ left: curPercentage + '%' }"></div>
      <div class="bmi-item" v-for="(item, index) in bmiList" :key="index"></div>
    </div>
    <div class="bmi-text-list">
      <div class="bmi-text-item" v-for="(item, index) in bmiList" :key="index">
        <div>{{ item.text }}</div>
        <div>{{ item.range }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    bmi: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      curPercentage: 0,
      bmiList: [
        {
          text: '偏瘦',
          range: '<18.5',
          min: -Infinity,
          max: 18.5
        },
        {
          text: '正常',
          range: '18.5-24',
          min: 18.5,
          max: 24
        },
        {
          text: '偏重',
          range: '24-28',
          min: 24,
          max: 28
        },
        {
          text: '肥胖',
          range: '≥28',
          min: 28,
          max: +Infinity
        }
      ]
    }
  },
  watch: {
    bmi(val) {
      this.updateBmi(val)
    }
  },
  created() {
    this.updateBmi(this.bmi)
  },
  methods: {
    updateBmi(curBmi) {
      curBmi = curBmi < 0 ? 0 : curBmi
      let curPercentage = 0 //箭头指向多少百分比
      let rangePercent = 100 / this.bmiList.length //每个范围占多少百分比
      let curindex = 0 //bmi处于第几个范围
      for (let i = 0; i < this.bmiList.length; i++) {
        let item = this.bmiList[i]
        if (curBmi >= item.min && curBmi < item.max) {
          curindex = i
        }
      }
      if (curindex == 0) {
        let min = curBmi / 1.5
        curPercentage =
          curindex * rangePercent +
          ((curBmi - min) / (this.bmiList[curindex].max - min)) * rangePercent
      } else if (curindex == this.bmiList.length - 1) {
        let max = curBmi * 1.5
        curPercentage =
          curindex * rangePercent +
          ((curBmi - this.bmiList[curindex].min) /
            (max - this.bmiList[curindex].min)) *
            rangePercent
      } else {
        curPercentage =
          curindex * rangePercent +
          ((curBmi - this.bmiList[curindex].min) /
            (this.bmiList[curindex].max - this.bmiList[curindex].min)) *
            rangePercent
      }
      this.curPercentage = curPercentage
    }
  }
}
</script>
<style lang="scss" scoped>
.bmi-container {
  width: 100%;
  margin-bottom: 5.87vw;
}
.bmi-flex {
  width: 100%;
  position: relative;
  height: 2.67vw;
  background-image: linear-gradient(
    90deg,
    #7693ea 0%,
    #b876ae 50%,
    #fa5a73 100%
  );
  border-radius: 3.2vw;
  display: flex;
  align-items: center;
  margin-bottom: 1.6vw;
}
.flag {
  position: absolute;
  left: 0;
  top: -4vw;
  height: 0;
  width: 0;
  transform: translate(-50%);
  border-left: 1.33vw solid transparent;
  border-right: 1.33vw solid transparent;
  border-top: 2.93vw solid #000;
  border-bottom: 0px solid transparent;
}
.bmi-flex .bmi-item {
  flex: 1;
  height: 1.33vw;
  border-right: 1px solid #fff;
  box-sizing: border-box;
}
.bmi-flex .bmi-item:last-child {
  border-right: none;
}
.bmi-text-list {
  display: flex;
  align-items: center;
  font-size: 3.2vw;
  color: #202025;
}
.bmi-text-item {
  text-align: center;
  flex: 1;
  overflow: hidden;
}
</style>
